import { User } from './user.user';

export class SIAUser extends User {}
